import { render, staticRenderFns } from "./LmTableCustom.vue?vue&type=template&id=2cc83b1a&scoped=true&"
import script from "./LmTableCustom.vue?vue&type=script&lang=js&"
export * from "./LmTableCustom.vue?vue&type=script&lang=js&"
import style0 from "./LmTableCustom.vue?vue&type=style&index=0&id=2cc83b1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc83b1a",
  null
  
)

export default component.exports